;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["gatewaysales", "gatewaysalesencoded", "default_currency"],
  data: function data() {
    return {
      sales: [],
      sales_encoded: []
    };
  },

  created: function created() {},
  watch: {
    gatewaysales: function gatewaysales(val) {
      this.sales = val;

      this.render_revenue_graph();
    },
    gatewaysalesencoded: function gatewaysalesencoded(val) {
      this.sales_encoded = val;

      this.render_pg_graphs();
    }
  },

  methods: {
    render_revenue_graph: function render_revenue_graph() {
      var gatewaySales = this.sales;
      $("#payment-gateway-revenue").highcharts({
        chart: {
          type: "column",
          inverted: true
        },
        title: {
          enabled: false,
          text: "Payment Gateway Breakdown"
        },
        xAxis: {
          gridLineWidth: 1,
          categories: gatewaySales.map(function (gt) {
            return gt.gateway_name;
          }),
          title: { text: "Gateways" }
        },
        yAxis: {
          gridLineWidth: 1,
          title: {
            text: "Number Of Invoices"
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0003",
          name: this.default_currency + " Payments",
          data: gatewaySales.map(function (gt) {
            return parseInt(gt.num_invoices_kes);
          })
        }, {
          lineWidth: 2,
          color: "#3C009B",
          name: "USD Payments",
          data: gatewaySales.map(function (gt) {
            return parseInt(gt.num_invoices_usd);
          })
        }]
      });
    },
    render_pg_graphs: function render_pg_graphs() {
      var gatewaySales = JSON.parse(this.sales_encoded);
      $("#paymentGateways").highcharts({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          height: 350,
          padding: 0,
          margin: 0,
          spacing: 0
        },
        title: {
          text: ""
        },
        legend: {
          enabled: false,
          align: "center",
          layout: "horizontal",
          verticalAlign: "top",
          alignColumns: false,
          margin: 30
        },
        tooltip: {
          headerFormat: "",
          pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {point.name}: <b>{point.y}</b>%<br/>"
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            showInLegend: true,
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          minPointSize: 10,
          innerSize: "20%",
          zMin: 0,
          name: "Payment Gateways",
          data: gatewaySales
        }]
      });
    }

  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row justify-content-between align-items-stretch"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col card margin-bottom-20"},[_c('div',{staticClass:"card-header tbn-tabs"},[_c('div',{staticClass:"form-row row-eq-height"},[_c('div',{staticClass:"col-8 col-md-8"},[_c('br'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.default_currency)+" / USD Revenue - Last 7 Days")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("Payment Gateway Breakdown")])]),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-4"})])]),_vm._v(" "),_vm._m(1)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col card margin-bottom-20",attrs:{"id":"dashboard-orders-card"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-8 col-md-8"},[_c('br'),_vm._v(" "),_c('h4',[_vm._v("Payment Gateways - Last 7 Days")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("Applications/Payment gateways breakdown")])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"paymentGateways"}})])])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"payment-gateway-revenue"}})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03b8ad68", __vue__options__)
  } else {
    hotAPI.reload("data-v-03b8ad68", __vue__options__)
  }
})()}